import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { NgbDateStruct, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { Task, WpPerson, Appointment, AssessmentSummary, WpReferral, AppointmentCorrespondence, ClientInformation } from '../shared';
import { DateUtility, TimeUtility, CommonUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { PersonProvider } from "../shared/model/PersonProvider";
import { ContactHistory } from "../shared/model/contactHistory.model";
import { ProviderOffice } from "../shared/model/ProviderOffice";
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
  providers: [NgbTimepickerConfig]
})
export class AppointmentComponent implements OnInit, CanComponentDeactivate {
  referralId: string = '';
  wpPersonId: string = '';
  providerId: string = '';

  personProvider: PersonProvider;
  serviceCountyForPerson: number;
  providerForPerson: number;

  personCounty: string = '';

  userCounties: any;

  countiesArr: Array<any> = [];
  locations: Array<any> = [];



  appointment: Appointment;
  appointmentClone: Appointment;
  appointments: Appointment[];
  appointmentTypes: any;
  appointmentStatus: any;
  appointmentMethod: any;
  appointmentLocation: any;

  countyCds: Array<any>;
  countyMap: Map<string, string>;
  appointmentMethodMap: Map<string, string>;
  appointmentTypesMap: Map<string, string>;

  appointmentTime: any;
  url: String = '';
  sub: any;
  alreadyExist: Boolean = false;
  task: Task;
  wpPerson: WpPerson;
  wpReferral: WpReferral;
  time: NgbTimeStruct = { hour: 8, minute: 0, second: 0 };
  private _danger = new Subject<string>();
  errorMessage: string;
  private _success = new Subject<string>();
  successMessage: string;
  serverConstants: any;
  // copyAppointmentStatus: any;
  refData: any;
  appointmentStatusMap: any;
  disableDropDown: Boolean = false;
  hours: any;
  minutes: any;
  meridian: any;
  selectedMin: any;
  selectedHour: any;
  selectedMer: any;

  appointmentDt: any;

  disableButton: Boolean = false;
  userActionNotificationsMap: any;
  sharedData: any;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  today: Date = new Date();
  todayPlus: Date = new Date();
  errorAptDateField: string = null;

  isResetDisable: boolean;
  enrollmentId;
  programCd;
  enrollment;
  assessmentFlag = true;
  providerOffices: ProviderOffice[] = [];
  isChangeDetected: boolean;
  appointmentCorrespondence: AppointmentCorrespondence;

  isPrintVisible: boolean = false;
  taskDueDates:any[];
  taskDueDatesMap:any;
  taskDueDate:any;
  caseinfo:any;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;

  clientInfo: ClientInformation;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    config: NgbTimepickerConfig,
    private dateUtil: DateUtility,
    private timeUtil: TimeUtility,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private router: Router,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();

    config.seconds = false;
    config.spinners = false;
    this.hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    this.minutes = ["00", "15", "30", "45"];
    this.meridian = ["AM", "PM"];
    this.selectedHour = "";
    this.selectedMin = "";
    this.selectedMer = "AM";

    this.isResetDisable = true;
    if (this.dataService.getSharedDataObject().get('APPTS') == undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.caseinfo = this.dataService.getSharedDataObject().get('APPTS').innerNavPages[0].readOnly;
    console.log(this.caseinfo);
    console.log(this.dataService.getSharedDataObject().get('APPTS').innerNavPages[0]);
    console.log(this.dataService.getSharedDataObject().get('APPTS').innerNavPages[1]);

    console.log('page 1: ' +  this.dataService.getSharedDataObject().get('APPTS').innerNavPages[0]);
    console.log('page 2: ' +  this.dataService.getSharedDataObject().get('APPTS').innerNavPages[1]);

    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.countiesArr = this.sharedData.get('userCounties');
    this.providerId = this.sharedData.get('providerId');
    this.taskDueDates = this.data.getValueFromSharedDataMap('TASKDUEDATES');
    this.taskDueDatesMap = this.commonUtil.createMapFromList(this.taskDueDates);

    this.personProvider = this.sharedData.get('personProvider');
    this.serviceCountyForPerson = this.personProvider.id.serviceCounty;
    this.providerForPerson = this.personProvider.id.providerId;
    this.personCounty = this.sharedData.get('personServiceCounty');

    if (this.sharedData.get('etEnrollmentId') !== null && this.sharedData.get('etEnrollmentId') !== undefined) {
      this.enrollmentId = Number(this.sharedData.get('etEnrollmentId'));
    }

    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.enrollment = this.sharedData.get('etEnrollment');
    }

    if (this.sharedData.get('programCd') !== null && this.sharedData.get('programCd') !== undefined) {
      this.programCd = this.sharedData.get('programCd');
    }

    this.parseRefTableData();
    this.loadProviderOffices();
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadClientInfoFromAries(this.sharedData.get('personProvider').emciId) : this.loadClientInfoFromAnswer();
    //this.loadClientInfoFromAnswer();
    this.changeTaskDueDate();

    this.wpPerson = new WpPerson();
    this.wpPerson.id = parseInt(this.wpPersonId);

    this.wpReferral = new WpReferral();
    if (this.referralId != undefined || this.referralId != null) {
      this.wpReferral.id = parseInt(this.referralId);
    }

    this.appointment = new Appointment();

    this.task = new Task();

    if (this.sharedData.get('appTaskId') != undefined) {
      this.task.id = parseInt(this.sharedData.get('appTaskId'));

    } else {
      this.task.wpPerson = this.wpPerson;
      this.task.wpReferral = this.wpReferral;

      // Assigned  task to the Provider or County Worker
      if (this.providerId != undefined || this.providerId != null) {
        this.task.assignedToInd = "P";
        this.task.assignedTo = this.providerForPerson + "";
      } else {
        this.task.assignedToInd = "C";
        this.task.assignedTo = this.serviceCountyForPerson + "";
      }

      this.task.programCd = "FS";
      this.task.taskType = "AP";
    }

    this.appointment.wpTask = this.task;
    this.appointment.wpPerson = this.wpPerson;
    this.appointment.referralId = parseInt(this.referralId);

    this.appointmentClone = Object.assign({}, this.appointment);

    this.load(this.appointment);
    this.checkAssessment();
  }

  convertCode(myMap, code) {
    if (myMap != undefined) {
      return myMap.get(code);
    }
  }


  load(appointment) {
    var time;
    this.http.post<Appointment[]>(this.serverConstants.SERVER_API_URL + '/appointment/load', appointment).subscribe(
      (data: Appointment[]) => {
        if (data == null || data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
          this.appointment = new Appointment();
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
          //this.fileInput.nativeElement.click();
        } else {
          if (data != undefined && data.length > 0) {
            /* Always get the first appointment to display*/

            this.isResetDisable = false;

            this.appointment = data[0];

            console.log(this.appointment);

            this.disableDropDown = false;
            this.disableButton = false;
            if (this.appointment.id != null) {
              this.alreadyExist = true;
            }
            /* Date conversions */
            if (this.appointment.appointmentDt != null) {

              this.appointmentDt = this.dateUtil.convertDateFromServer(this.appointment.appointmentDt);
            }
            if (this.appointment.appointmentTime != null) {
              time = this.timeUtil.convertMeridianTimeFromServer(this.appointment.appointmentTime);
              //console.log(this.selectedHour, this.selectedMin, this.selectedMer )
              this.selectedHour = time[0];
              this.selectedMin = time[1];
              this.selectedMer = time[2];
            }

            if (this.appointment.appointmentStatusCd == '') {
              this.appointment.appointmentStatusCd == '';
            } else if (this.appointment.appointmentStatusCd == null) {
              this.appointment.appointmentStatusCd = null;
            } else if (this.appointment.appointmentStatusCd == "null") {
              this.appointment.appointmentStatusCd = "null";
            } else if (this.appointment.appointmentStatusCd == 'SH') {
              /* Remove To be scheduled and Scheduled*/
              this.isPrintVisible = true;
              this.appointmentStatus = this.appointmentStatus.filter(function (item) {
                if (item.value == "null" || item.value == '') {
                  return false;
                } else {
                  return true;
                }
              });
              this.disableDropDown = false;
            } else if (this.appointment.appointmentStatusCd == 'RS') {
              /* Remove To be scheduled and Scheduled*/
              this.appointmentStatus = this.appointmentStatus.filter(function (item) {
                if (item.value == 'null' || item.value == 'SH' || item.value == "null") {
                  return false;
                } else {
                  return true;
                }
              });
              this.disableDropDown = false;
            } else if (this.appointment.appointmentStatusCd == 'NS') {
              this.disableDropDown = true;
              this.disableButton = true;
            } else if (this.appointment.appointmentStatusCd == 'CO') {
              this.disableDropDown = true;
              this.disableButton = true;
            }

          } else {
            /* New Record */
            this.appointment = appointment;
            /* Set status to To be scheduled*/
            this.appointment.appointmentStatusCd = "null";
            this.disableDropDown = true;
            this.minDate = {
              month: this.today.getMonth() + 1,
              day: this.today.getDate(),
              year: this.today.getFullYear()
            };

            this.todayPlus = new Date(this.todayPlus.setMonth(this.todayPlus.getMonth() + 6));
            this.maxDate = {
              month: this.todayPlus.getMonth() + 1,
              day: this.todayPlus.getDate(),
              year: this.todayPlus.getFullYear()
            };
          }
        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);
        //this.fileInput.nativeElement.click();
      },
      () => {
      });
  }


  loadProviderOffices() {
    this.locations = [];
    this.http.post<ProviderOffice[]>(this.serverConstants.SERVER_API_URL + "/providerOffice/providerAndCounty", { providerId: this.providerForPerson, countyId: this.serviceCountyForPerson} ).subscribe(
      (data: ProviderOffice[]) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Provider Office', this.userActionNotificationsMap.ERROR);
        }
        else {
          if (data != null) {
            this.providerOffices = data;
            this.locations.push({ name: "Pick an Option", value: undefined });
            //this.locations.push({ name: "Virtual", value: "VR" });
            for (let location of this.providerOffices) {
              this.locations.push({ name: location.officeName, value: location.id + "" });
            }
          }
        }
      },
      response => {
        this.notificationService.error('Provider Office', this.userActionNotificationsMap.ERROR);
      },
      () => {
        this.dataService.addValueToSharedDataMap("providerOffice", this.locations);
      });
  }

  reset() {
    if (!this.isResetDisable) {
      this.appointment = this.appointmentClone;
      this.load(this.appointment);
    } else {
      this.appointmentDt = "";
      this.selectedHour = "";
      this.selectedMin = "";
      this.selectedMer = "AM";

      this.appointment.appointmentType = undefined;
      this.appointment.appointmentMethodCd = undefined;
      this.appointment.appointmentLocation = undefined;
    }

  }

  toggleButton() {
    this.alreadyExist = false;
    return this.alreadyExist;
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  scheduleAppointment() {
    this.isChangeDetected = false;
    /* convert date and also change status to Schedule */
    this.appointment.appointmentDt = this.dateUtil.convertDateForServer(this.appointmentDt);

    if (this.selectedHour != "" && this.selectedMin != "") {
      this.appointment.appointmentTime = this.timeUtil.convertMeridianTimeForServer(this.appointment.appointmentDt, this.selectedHour, this.selectedMin, this.selectedMer);
    }
    //this.appointment.appointmentTime = this.timeUtil.convertTimeForServer(this.appointment.appointmentDt, this.appointment.appointmentTime);
    if (this.appointment.appointmentStatusCd == '' || this.appointment.appointmentStatusCd == null || this.appointment.appointmentStatusCd == "null") {
      this.appointment.appointmentStatusCd = 'SH';
    } else if (this.appointment.appointmentStatusCd == 'SH') {
      this.appointment.appointmentStatusCd = 'RS';
    }
    let request: RequestAppointment;
    if(this.caseinfo){
      this.assessmentFlag = false;
    }
      let startDt = this.dateUtil.convertDateFromServer(this.dateUtil.getFormattedSystemDateFromModelForServer());

      let dueDt = new Date();
      dueDt = this.dateUtil.addDays(dueDt, 30);
      startDt = this.dateUtil.convertDateForServer(startDt);

      //const dueDtStr1=dueDt.getFullYear()+"/"+ (dueDt.getMonth()+1)+"/"+dueDt.getDate();
      const dueDtStr1 = this.dateUtil.formatDate(dueDt);
      const assessment = new AssessmentSummary(this.enrollment.programCd, this.enrollment.id, 'OP', startDt, dueDtStr1);

      request = new RequestAppointment(this.appointment, assessment, this.assessmentFlag);

    let answerFlag = true;
    if (this.appointment.appointmentStatusCd === 'SH' || this.appointment.appointmentStatusCd === 'RS') {
      answerFlag = false;
      const appointmentCORequest = new AppointmentCORequest();
      if (this.clientInfo !== undefined) {

        appointmentCORequest.mailingAddrLine1 = this.clientInfo.MAILING_ADDR_LINE1;
        appointmentCORequest.mailingAddrLine2 = this.clientInfo.MAILING_ADDR_LINE2;
        appointmentCORequest.mailingAddrCity = this.clientInfo.MAILING_ADDR_CITY;
        appointmentCORequest.mailingAddrState = this.clientInfo.MAILING_ADDR_STATE;
        appointmentCORequest.mailingAddrZip = this.clientInfo.MAILING_ADDR_ZIP;
      
        //if(this.appointment.appointmentLocation === 'VR') {
         // if(appointmentCORequest.clientPhone != null || appointmentCORequest.clientPhone != undefined) {
            appointmentCORequest.clientPhone = this.clientInfo.MESSAGE_PHONE;
       /*   } else{
            appointmentCORequest.clientPhone = ' ';
          }
        } else {
          appointmentCORequest.clientPhone = ' ';
        }*/
        
        console.log('Client Phone: ' + appointmentCORequest.clientPhone);
        
        answerFlag = true;
      }
      if (this.providerOffices.length > 0) {

        this.providerOffices.forEach(office => {
          if (office.id === Number(this.appointment.appointmentLocation)) {
            appointmentCORequest.primaryAddrLine1 = office.primaryAddrLine1;
            appointmentCORequest.primaryAddrLine2 = office.primaryAddrLine2;
            appointmentCORequest.primaryCity = office.primaryCity;
            appointmentCORequest.primaryState = office.primaryState;
            appointmentCORequest.primaryZip5 = office.primaryZip5;
            appointmentCORequest.primaryZip4 = office.primaryZip4;
            appointmentCORequest.providerPhoneNumber = office.primaryPhoneNumber;
            appointmentCORequest.providerPhoneNumberExt = office.primaryPhoneNumberExt;
            appointmentCORequest.officeName = office.officeName;
          }
        });

      }
      
      appointmentCORequest.appointmentMethodCd = this.appointment.appointmentMethodCd;
      console.log('Appointment Method: ' + appointmentCORequest.appointmentMethodCd);

      let wpPerson;
      if (this.sharedData.get('wpPerson') !== null && this.sharedData.get('wpPerson') !== undefined) {
        wpPerson = this.sharedData.get('wpPerson');
      }

      appointmentCORequest.clientName = wpPerson.firstName + ' ' + wpPerson.lastName;
      appointmentCORequest.caseNumber = this.enrollment.person.budgetUnitId;
      appointmentCORequest.appointmentDt = this.appointment.appointmentDt;
      appointmentCORequest.appointmentTime = this.appointment.appointmentTime;
      appointmentCORequest.appointmentStatus = this.appointment.appointmentStatusCd;
      request.appointmentCORequest = appointmentCORequest;
    }
    if(this.assessmentFlag == true && request.appointment.appointmentStatusCd == 'CO'){
      this.getWPC();
    }
    //if (answerFlag) {
      this.http.post(this.serverConstants.SERVER_API_URL + "/appointment/save", request).subscribe(
        (val) => {
          if (val == null || val.hasOwnProperty('errorCode')) {
            if (this.appointment.appointmentDt != null) {
              this.appointmentDt = this.dateUtil.convertDateFromServer(this.appointment.appointmentDt);
            }
            if (this.appointment.appointmentTime != null) {
              var time = this.timeUtil.convertMeridianTimeFromServer(this.appointment.appointmentTime);
              this.selectedHour = time[0];
              this.selectedMin = time[1];
              this.selectedMer = time[2];
            }

            if(this.appointment.appointmentStatusCd === 'SH') {
              this.notificationService.error('Appointment','Unable to send notification to the eligibility system; system will retry later.');   
             ///this.disableButton = true;
            } else {
              //Display Error notification
              this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
              setTimeout(() => this.fileInput.nativeElement.focus(), 0);
              //this.fileInput.nativeElement.click();
            }
           
          } else {

            if (val != null) {
              this.appointment = val;

              if (this.appointment.appointmentDt != null) {
                this.appointmentDt = this.dateUtil.convertDateFromServer(this.appointment.appointmentDt);
              }
              if (this.appointment.appointmentTime != null) {

                var time = this.timeUtil.convertMeridianTimeFromServer(this.appointment.appointmentTime);
                this.selectedHour = time[0];
                this.selectedMin = time[1];
                this.selectedMer = time[2];
              }

              /*Show success and make them readonly */
              if (this.appointment.appointmentStatusCd === 'SH' && this.appointment.id != null) {
                this.dataService.removeValueFromSharedDataMap('appTaskId');
                this.closeReferral();
                this.notificationService.success('Appointment', "Appointment scheduled");

                this.appointmentStatus = this.appointmentStatus.filter(function (item) {
                  if (item.value === '' || item.value === "null") {
                    return false;
                  } else {
                    return true;
                  }
                });
                this.disableDropDown = false;
                this.alreadyExist = true;
                /* this.router.navigate(['task']);*/
                this.isPrintVisible = true;
              } else if (this.appointment.appointmentStatusCd == 'RS') {
                this.notificationService.success('Appointment', this.userActionNotificationsMap.UPDATE);
                /* Remove To be scheduled and Scheduled*/
                this.appointmentStatus = this.appointmentStatus.filter(function (item) {
                  if (item.value == '' || item.value == 'SH' || item.value == "null") {
                    return false;
                  } else {
                    return true;
                  }
                });
                this.disableDropDown = false;
                this.isPrintVisible = true;
                /*this.router.navigate(['task']);*/
                //Non Compliance
              } else if (this.appointment.appointmentStatusCd == 'NS') {
                this.notificationService.success('Appointment', this.userActionNotificationsMap.UPDATE);
                this.disabledAllFields();
                this.router.navigate(['task/caseNotesSummary']);
              } else if (this.appointment.appointmentStatusCd == 'CO') {
                this.disabledAllFields();
                this.notificationService.success('Appointment', this.userActionNotificationsMap.UPDATE);
                this.router.navigate(['task/assessmentSummary']);

              }

            }
          }
        },
        response => {

          if(this.appointment.appointmentStatusCd === 'SH') {
            this.notificationService.error('Appointment','Unable to send notification to the eligibility system; system will retry later.');   
            //this.disableButton = true;
          } else {
            this.appointment.appointmentStatusCd = undefined;
            this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
            setTimeout(() => this.fileInput.nativeElement.focus(), 0);
            //this.fileInput.nativeElement.click();
          } 
         
        },
        () => {

        });
    // } else {
    //   this.notificationService.error('Appointment', 'Unable to get client information from ANSWER');
    // }
  }
  parseRefTableData() {

    this.appointmentTypes = this.data.getValueFromSharedDataMap("appointmentType");
    this.appointmentStatus = this.data.getValueFromSharedDataMap("appointmentStatus");
    this.appointmentMethod = this.data.getValueFromSharedDataMap("appointmentMethod");
    this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');

    //this.appointmentLocation = this.data.getValueFromSharedDataMap("appointmentLocation");
    this.countyMap = this.commonUtil.createMapFromList(this.countyCds);
    this.countyMap.set(undefined, "Pick an option");
    this.appointmentMethodMap = this.commonUtil.createMapFromList(this.appointmentMethod);
    this.appointmentTypesMap = this.commonUtil.createMapFromList(this.appointmentTypes);

    this.appointmentStatusMap = this.commonUtil.createMapFromList(this.appointmentStatus);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
  }

  disabledAllFields() {
    this.disableDropDown = true;
    this.disableButton = true;
    this.alreadyExist = true;
  }

  StatusChange(event) {
    if (this.appointment.appointmentStatusCd == 'RS') {
      this.toggleButton();
    }
  }

  minValidDate(status) {
    if (status === "RS") {
      this.minDate = {
        month: this.today.getMonth() + 1,
        day: this.today.getDate(),
        year: this.today.getFullYear()
      };
      this.todayPlus = new Date(this.todayPlus.setMonth(this.todayPlus.getMonth() + 6));
      this.maxDate = {
        month: this.todayPlus.getMonth() + 1,
        day: this.todayPlus.getDate(),
        year: this.todayPlus.getFullYear()
      };
    }
  }


  validAptDate() {

    if (!this.alreadyExist
      && this.appointmentDt !== undefined
      && this.appointmentDt !== null) {
      let aptDt = new Date(this.appointmentDt.year,
        this.appointmentDt.month - 1,
        this.appointmentDt.day);
      let minDt = new Date(this.minDate.year,
        this.minDate.month - 1,
        this.minDate.day);
      let maxDt = new Date(this.maxDate.year,
        this.maxDate.month - 1,
        this.maxDate.day);

      if (aptDt < minDt || aptDt > maxDt) {
        this.errorAptDateField = 'Please select a date between today and six months ahead';
      } else {
        this.errorAptDateField = null;
      }
    }
  }

  printCorrespondence() {
    this.dataService.addValueToSharedDataMap("appointmentCorrespondence", this.appointment);
    this.router.navigate(['task/correspondence']);
  }

  checkAssessment() {
    this.http.post<AssessmentSummary[]>(this.serverConstants.SERVER_API_URL + '/assessment-summary/load/summary', { enrollmentId: this.enrollment.id }).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {

        } else {
          if (data.length > 0) {

            data.forEach(element => {
              if (element.statusCd === 'OP' || element.statusCd === 'IP') {
                this.assessmentFlag = false;

              } else {
                this.assessmentFlag = true;
              }
            });

          } else {
            this.assessmentFlag = true;
          }
        }
      }, response => {
      }, () => {

      });
  }

  focusing() {
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    this.fileInput.nativeElement.click();
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      if (!this.alreadyExist) {
        e.preventDefault();
        setTimeout(() => this.headerText.nativeElement.focus(), 0);
        this.headerText.nativeElement.click();
      }
    }
  }

  focusHeaderPrint(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  loadClientInfoFromAries(emciId){
    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/clientInfo/' + emciId + "/null").subscribe(
      (data: Array<Object>) => {
        console.log(' data =: ' + data);
        this.clientInfo = new ClientInformation();
        if (data !== null && data !== undefined && data.length > 0) {
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA');
          this.clientInfo.MAILING_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.MAILING_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.MAILING_ADDR_CITY=address["addrCity"];
          this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.MAILING_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.MAILING_ADDR_ZIP=address["addrZip5"];
        }
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA');
          //(this.clientInfo.RESIDENTIAL_COUNTY === null && address["addrCountyCd"] !== null) ? this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"] : this.clientInfo.RESIDENTIAL_COUNTY=this.clientInfo.RESIDENTIAL_COUNTY;
          //this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.MAILING_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.MAILING_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.MAILING_ADDR_CITY=address["addrCity"];
          this.clientInfo.MAILING_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.MAILING_ADDR_ZIP=address["addrZip5"];
        }
          this.clientInfo.CLIENTID = data[0]["indvId"];
          this.clientInfo.FIRST_NAME = data[0]["firstName"];
          this.clientInfo.LAST_NAME = data[0]["lastName"];
          this.clientInfo.MESSAGE_PHONE = data[0]["primaryPhnNum"];
          this.clientInfo.WORK_PHONE = data[0]["workPhnNum"];
          this.clientInfo.RESIDENTIAL_PHONE = data[0]["altPhnNum"];
          this.clientInfo.PRIMARY_LANGUAGE = data[0]["primaryLang"];
          this.clientInfo.EMCI_ID = data[0]["indvId"];
          if(data[0]["genderCd"] === 'M'){
            this.clientInfo.GENDER_CD = "Male";
          }
          else{
            this.clientInfo.GENDER_CD = "Female";
          }

        } else {
          // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
          // notification to be changed to red, and changed to the following verbiage: 'Case Closed. SNAP Case is closed.'
          this.notificationService.warn('Appointment', 'Client Summary Information not found in Eligibility System');
        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
      },
      () => {
        //this.notificationService.warn('Appointment', 'Client Summary Information not found in Eligibility System');
      });

  }

  loadClientInfoFromAnswer() {
    const ssnValue = this.sharedData.get('SSN_SEARCH');

    this.http.get<ClientInformation[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetDemographic/' + ssnValue).subscribe(
      (data: ClientInformation[]) => {
        if (data !== null && data !== undefined && data.length > 0) {
          this.clientInfo = data[0];
          if(this.clientInfo.MAILING_ADDR_LINE1 == ""){
            this.clientInfo.MAILING_ADDR_LINE1 = null;
          }

        } else {
          this.notificationService.warn('Appointment', 'Client Summary Information not found in Eligibility System');
        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }
  closeReferral(){
    let referralSearch ={"assignedTo":"PN","task":{"taskType":"RF","taskStatus":null,"programCd":"FS","assignedUser":null,"wpReferral":{"id":this.referralId},"wpPerson":{"id":this.wpPersonId}},"completionDtSw":"N"};
    this.http.post(this.serverConstants.SERVER_API_URL + '/tasks/search',referralSearch ).subscribe((data)=>{
      console.log("Referral tasks:" + data);
      if(data["tasks"].length > 0){
        data["tasks"].forEach((element)=>{
          element.taskStatus = "CO";
          this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/tasks/save', element).subscribe((data1)=>{
            console.log("Referral task Closure Success:" + data1)
          },error1=>{
            console.log("Referral task Closure Failure:" + error1);
          })
        })
      }
    },error=>{
      console.log("Referral tasks Error:" + error);
    })
  }
  getWPC(){
    let etTask = new Task();
    this.sharedData = this.dataService.getSharedDataObject();
    console.log(this.sharedData.get('personServiceCounty'));
    let ssnValue = this.sharedData.get('SSN_SEARCH');
    let person: WpPerson = new WpPerson();
    person.id = parseInt(this.sharedData.get('wpPersonId'), 10);

    let referral: WpReferral = new WpReferral();
    referral.id = parseInt(this.sharedData.get('referralId'), 10);
    etTask.taskType = "ET";
    etTask.wpPerson = person
    etTask.wpReferral = referral;
    etTask.taskStatus = "OP";
    etTask.assignedTo = this.sharedData.get('personServiceCounty');
    etTask.assignedToInd = "C";
    etTask.programCd = "FS";
    etTask.taskDueDt = this.taskDueDate;
    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientWorkParticipation/'
      + ssnValue).subscribe((data)=>{
        if(!data["errorCode"]){
          if(data[0].WORK_PART != "5E"){
            this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/tasks/save', etTask).subscribe((data)=>{
              console.log(data);
              if(!data["errorCode"]){
                this.notificationService.success('E&T Participation task has been Created');
              }
            },error=>{
              console.log(error);
            })
          }
        }
        else{
          this.notificationService.warn('Unable to create E&T Participating task', 'SSN not found in ABAWD group in Eligibility System');
        }
      },error=>{
        this.notificationService.warn('Unable to create E&T Participating task', 'SSN not found in Eligibility System');
      });
  }
  changeTaskDueDate() {
    for (const taskDD of this.taskDueDates) {
      if (taskDD.value == "ET") {
        const taskDueDt = new Date();
        taskDueDt.setDate(taskDueDt.getDate() + Number(taskDD.name));
        const dueDtMonth = (taskDueDt.getMonth() + 1) >= 10 ? '' + (taskDueDt.getMonth() + 1) : '0' + (taskDueDt.getMonth() + 1);
        const taskDueDtStr = (taskDueDt.getFullYear() + '/' + dueDtMonth + '/' + taskDueDt.getDate());
        this.taskDueDate = taskDueDtStr;
        break;
      }
    }
  }


}

class RequestAppointment {
  constructor(
    public appointment: any,
    public assessment?: AssessmentSummary,
    public assessmentFlag?: Boolean,
    public appointmentCORequest?: AppointmentCORequest
  ) {
  }
}


class AppointmentCORequest {
  constructor(
    public officeName?: string,
    public clientName?: string,
    public caseNumber?: string,
    public providerPhoneNumber?: string,
    public providerPhoneNumberExt?: string,
    public primaryAddrLine1?: string,
    public primaryAddrLine2?: string,
    public primaryCity?: string,
    public primaryState?: string,
    public primaryZip5?: string,
    public primaryZip4?: string,
    public appointmentDt?: string,
    public appointmentTime?: string,
    public appointmentStatus?: string,
    public mailingAddrLine1?: string,
    public mailingAddrLine2?: string,
    public mailingAddrCity?: string,
    public mailingAddrState?: string,
    public mailingAddrZip?: string,
    public clientPhone?: string,
    public appointmentMethodCd?: string
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/appointment/appointment.component.ts